import { z } from "zod";

export const httpHeaderFormSchema = z.object({
	name: z
		.string()
		.min(1, "Name is required")
		.regex(/^[\w-]+$/, "Must be Alphanumeric or _ or -"),
	value: z
		.string()
		.min(1, "Value is required")
		.regex(/^[\w\- ]+$/, "Must be Alphanumeric, space, _ or -"),
});

export type HttpHeaderForm = z.infer<typeof httpHeaderFormSchema>;
